import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import { SignUpComponent } from '../sign-up/sign-up.component';
import { SignInForgotPasswordComponent } from '../sign-in-forgot-password/sign-in-forgot-password.component';


@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit {

  constructor(
    public authService: AuthService,
    public dialogRefActual: MatDialogRef <SignInComponent>,
    public dialog: MatDialog) { }

  ngOnInit(): void {
  }

  openSignUp() {
    this.dialogRefActual.close();
    const dialogRef = this.dialog.open(SignUpComponent);
    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  // openForgotPassword() {
  //   const dialogRef = this.dialog.open(SignInForgotPasswordComponent);
  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log(`Dialog result: ${result}`);
  //   });
  // }

}
